import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { push } from 'react-router-redux';
import { NavLink } from 'react-router-dom';
import { Drawer } from 'rsuite';
import ReactGA from 'react-ga';
import getMenuByUserRoleAndFeatureAccess from '../../redux/data/menu';
import { getIsSidebarMenuShowing, hideSidebarMenu } from '../../redux/modules/header';
import {
  getIsUserAClient,
  getUserName,
  logout,
  getIsSso,
  getEngVideoCompilationEnabled
} from '../../redux/modules/auth';
import { FeatureRenderer } from '../../hoc/FeatureRenderer';
import { FEATURES, PLANS } from '../../plans-permissions';
import OrganizationMenu from './OrganizationMenu';
import styles from './SidebarMenu.module.less';

function handleUpgradeButtonClick(_push) {
  ReactGA.event({
    category: 'Header',
    action: 'Header upgrade link'
  });

  _push('/billing');
}

const SidebarMenu = ({
  _hideSidebarMenu,
  _logOut,
  _push,
  isSso,
  shouldShowSidebarMenu,
  userIsAClient,
  userName,
  user,
  videoCompilationEnabled
}) => {
  const isUserAClient = user && user.role === 2;

  const { main: items } = getMenuByUserRoleAndFeatureAccess(
    user && user.role,
    isUserAClient,
    isSso,
    videoCompilationEnabled
  );

  const renderNavItems = () => {
    return items?.map((item, key) => (
      <h4 className={styles.vpDrawerLink} key={key}>
        {item.text === 'Help Center' ? (
          <a href={item.url}>{item.text}</a>
        ) : (
          <NavLink to={item.url} activeClassName={styles.vpActiveLink}>
            {item.text}
          </NavLink>
        )}
      </h4>
    ));
  };
  return (
    <Drawer show={shouldShowSidebarMenu} onHide={_hideSidebarMenu}>
      <Drawer.Header>
        <Drawer.Title className={styles.vpSidebarTitle}>{userName}</Drawer.Title>
      </Drawer.Header>
      <Drawer.Body>
        <hr className={styles.vpDrawerSeparator} />
        {renderNavItems()}
        <hr className={styles.vpDrawerSeparator} />
        {userIsAClient && (
          <section>
            <h4 className={styles.vpDrawerLink}>
              <NavLink
                to="/billing"
                data-testid="billingDrawerLink"
                activeClassName={styles.vpActiveLink}
              >
                Billing
              </NavLink>
            </h4>
            <FeatureRenderer feature={FEATURES.organization_menu_link}>
              <h4 className={styles.vpDrawerLink}>
                <NavLink to="/organization" activeClassName={styles.vpActiveLink}>
                  Users
                </NavLink>
              </h4>
            </FeatureRenderer>
            <h4 className={styles.vpDrawerLink}>
              <NavLink to="/settings" activeClassName={styles.vpActiveLink}>
                Settings
              </NavLink>
            </h4>
            {!isSso && (
              <h4 className={styles.vpDrawerLink}>
                <NavLink to="/change/password" className="item">
                  Change Password
                </NavLink>
              </h4>
            )}
          </section>
        )}
        <hr className={styles.vpDrawerSeparator} />
        {userIsAClient && (
          <section>
            <FeatureRenderer
              feature={FEATURES.upgrade_button}
              constraints={{
                [PLANS.enterprise.key]: true
              }}
            >
              <h4 className={styles.vpDrawerLink}>
                <a
                  className=""
                  data-testid="upgradeDrawerLink"
                  onClick={() => {
                    handleUpgradeButtonClick(_push);
                  }}
                >
                  Upgrade
                </a>
              </h4>
            </FeatureRenderer>
            <h4 className={styles.vpDrawerLink}>
              <a
                className=""
                data-testid="feedbackDrawerLink"
                href="https://app.videopeel.com/c/ssthafdm"
                alt="Give us Feedback"
                target="_blank"
                rel="noreferrer"
              >
                Give us Feedback!
              </a>
            </h4>
            <hr className={styles.vpDrawerSeparator} />
            <OrganizationMenu />
            <h4 className={styles.vpDrawerLink}>
              <a href="" data-testid="logOutDrawerLink" onClick={_logOut}>
                Sign Out
              </a>
            </h4>
          </section>
        )}
      </Drawer.Body>
      <Drawer.Footer />
    </Drawer>
  );
};

SidebarMenu.propTypes = {
  _hideSidebarMenu: PropTypes.func,
  _logOut: PropTypes.func,
  _push: PropTypes.func,
  isSso: PropTypes.bool,
  shouldShowSidebarMenu: PropTypes.bool,
  userIsAClient: PropTypes.bool,
  userName: PropTypes.string,
  user: PropTypes.object,
  videoCompilationEnabled: PropTypes.bool
};

function mapStateToProps(state) {
  return {
    user: state.get('auth').get('user'),
    isSso: getIsSso(state),
    shouldShowSidebarMenu: getIsSidebarMenuShowing(state),
    userIsAClient: getIsUserAClient(state),
    userName: getUserName(state),
    videoCompilationEnabled: getEngVideoCompilationEnabled(state)
  };
}

const mapDispatchToProps = {
  _hideSidebarMenu: hideSidebarMenu,
  _logOut: logout,
  _push: push
};

export default connect(mapStateToProps, mapDispatchToProps)(SidebarMenu);



// WEBPACK FOOTER //
// ./src/components/Header/SidebarMenu.jsx